import { useContext } from 'react';
import { useSelector } from 'react-redux';
import CompanyContext from '../contexts/CompanyContext';
import { RootState } from '../store';

/**
 * Custom hook to access company context information
 * This hook combines data from both Redux store and React context
 */
export const useCompanyContext = () => {
  // Get company data from Redux store
  const { companyId, companyContext } = useSelector((state: RootState) => state.auth);
  
  // Get company data from React context (includes methods like switchCompany)
  const companyContextData = useContext(CompanyContext);
  
  return {
    // Data from Redux store
    companyId,
    currentCompanyId: companyContext.currentCompanyId,
    availableCompanies: companyContext.availableCompanies,
    
    // Data and methods from React context
    ...companyContextData,
    
    // Helper methods
    hasMultipleCompanies: 
      companyContext.availableCompanies !== null && 
      companyContext.availableCompanies.length > 1,
  };
};

export default useCompanyContext;